module.exports = {
  TED: 'TED',
  TEV: 'TEV',
  PIX: 'PIX',
  PIX_REFUND: 'PIX_REFUND',
  BILLET: 'BILLET',
  OTHER: 'OTHER'
};
